import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const HeadNav = ({
  allowPreviousSkill,
  allowNextSkill,
  currentSkill,
  onGoPreviousSkill,
  onGoNextSkill
}) => (
  <div className="row">
    <div className="col-xs-2">
      <a
        href="javascript:void(0);"
        className={classNames("text-right mobile-view-arrow", { disabled: !allowPreviousSkill })}
        onClick={onGoPreviousSkill}
      >
        <i className="material-icons">chevron_left</i>
      </a>
    </div>
    <div className="col-xs-8">
      <h3>{currentSkill}</h3>
    </div>
    <div className="col-xs-2">
      <a
        href="javascript:void(0);"
        className={classNames("mobile-view-arrow", { disabled: !allowNextSkill })}
        onClick={onGoNextSkill}
      >
        <i className="material-icons">chevron_right</i>
      </a>
    </div>
  </div>
);

HeadNav.propTypes = {
  allowPreviousSkill: PropTypes.bool.isRequired,
  allowNextSkill: PropTypes.bool.isRequired,
  currentSkill: PropTypes.string,
  onGoPreviousSkill: PropTypes.func.isRequired,
  onGoNextSkill: PropTypes.func.isRequired
};

export default HeadNav;
